import { MaterialItem } from '../../types/materials';

interface MaterialCardProps {
    item: MaterialItem;
    onView: (item: MaterialItem) => void;
    onDownload: (item: MaterialItem) => void;
}

const MaterialCard = ({ item, onView, onDownload }: MaterialCardProps) => {
    return (
        <div className="material-card">
            <div className="material-card__title">{item.title}</div>
            {item.description && <div className="material-card__description">{item.description}</div>}

            <div className="material-card__actions">
                <button type="button" className="material-btn material-btn--view" onClick={() => onView(item)}>
                    Ko'rish
                </button>
                <button type="button" className="material-btn material-btn--download" onClick={() => onDownload(item)}>
                    Yuklab olish
                </button>
            </div>
        </div>
    );
};

export default MaterialCard;
